var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7 53.1L28.9125 43.3125C28.0875 42.4875 27.075 42.075 25.875 42.075C24.675 42.075 23.625 42.525 22.725 43.425C21.9 44.25 21.4875 45.3 21.4875 46.575C21.4875 47.85 21.9 48.9 22.725 49.725L35.55 62.55C36.375 63.375 37.425 63.7875 38.7 63.7875C39.975 63.7875 41.025 63.375 41.85 62.55L67.3875 37.0125C68.2125 36.1875 68.625 35.175 68.625 33.975C68.625 32.775 68.175 31.725 67.275 30.825C66.45 30 65.4 29.5875 64.125 29.5875C62.85 29.5875 61.8 30 60.975 30.825L38.7 53.1ZM45 90C38.775 90 32.925 88.818 27.45 86.454C21.975 84.093 17.2125 80.8875 13.1625 76.8375C9.1125 72.7875 5.907 68.025 3.546 62.55C1.182 57.075 0 51.225 0 45C0 38.775 1.182 32.925 3.546 27.45C5.907 21.975 9.1125 17.2125 13.1625 13.1625C17.2125 9.1125 21.975 5.9055 27.45 3.5415C32.925 1.1805 38.775 0 45 0C51.225 0 57.075 1.1805 62.55 3.5415C68.025 5.9055 72.7875 9.1125 76.8375 13.1625C80.8875 17.2125 84.093 21.975 86.454 27.45C88.818 32.925 90 38.775 90 45C90 51.225 88.818 57.075 86.454 62.55C84.093 68.025 80.8875 72.7875 76.8375 76.8375C72.7875 80.8875 68.025 84.093 62.55 86.454C57.075 88.818 51.225 90 45 90Z",
    fill: "#319795"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.790b3fafb23b17eea1267fe6bc552a4d.svg";
export { ForwardRef as ReactComponent };